module.exports = __webpack_public_path__ + "static/pavlo_sapeha-1cfa05f475eb8bd757c4bf19480c26d1.png";